import { render, staticRenderFns } from "./FiltersSelect.vue?vue&type=template&id=2de99f98"
import script from "./FiltersSelect.vue?vue&type=script&lang=ts"
export * from "./FiltersSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports